import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ReactWMJSLayer, ReactWMJSMap, generateLayerId, WEBMAPJS_REDUCERNAME, webMapJSReducer, setBaseLayers, setLayers } from '@adaguc/react-webmapjs';
import { XAxis, YAxis, Tooltip, CartesianGrid, ReferenceLine, Area, AreaChart } from 'recharts';
import { GetFeatureInfo } from './GetFeatureInfo';
import { SPI_MONITOR_REDUCERNAME, spiMonitorReducer, handleErrorAction, l13ReadyAction, spiLoadingAction } from './SpiMonitorReducer';
import { getConfig } from './ConfigReader';
import { normaliseTimeDimensionUnits } from './TimeDimension';
import moment from 'moment';
import axios from 'axios';
import { Icon } from 'react-fa';
let config = getConfig();

const baseLayer = {
  name:'Positron_NL_NoLabels',
  title:'Positron_NL_NoLabels',
  type: 'twms',
  baseLayer: true,
  enabled: true,
  id: generateLayerId()
};

// const overLayerOld = {
//   service: 'http://geoservices.knmi.nl/cgi-bin/KlimaatAtlasShapes_RD.cgi?',
//   name: 'WN_NL_KlimaMask,WN_NL_KlimaProvinces',
//   format: 'image/png',
//   keepOnTop: true,
//   baseLayer: true,
//   enabled: true,
//   id: generateLayerId()
// };

const overLayer = {
  service: config.baselayerService,
  name: 'filledcountries,provinces,countryborders',
  format: 'image/png',
  keepOnTop: true,
  baseLayer: true,
  enabled: true,
  id: generateLayerId()
};
const spiLayerDaily = {
  service: config.SPIService,
  name: 'spi_daily_spi1',
  format: 'image/png',
  enabled: true,
  id: 'spiLayerDaily',
  opacity:1
};
const spiLayerForecast = {
  service: config.SPIService,
  name: 'spi_percentile_spi1',
  format: 'image/png',
  enabled: false,
  id: 'spiLayerForecast',
  opacity:1
};
const L13Layer = {
  service: config.L13Service,
  name: ['SPI_NL_1_10', 'SPI_NL_1_50', 'SPI_NL_1_90',
    'SPI_NL_3_10', 'SPI_NL_3_50', 'SPI_NL_3_90',
    'SPI_NL_6_10', 'SPI_NL_6_50', 'SPI_NL_6_90'].join(','),
  format: 'image/png',
  enabled: false,
  id: 'layer_L13_layer',
  opacity:1
};

class Content extends Component {
  constructor (props) {
    super(props);
    this.handleTimeData = this.handleTimeData.bind(this);
    this.renderDot = this.renderDot.bind(this);
    this.resize = this.resize.bind(this);
    this.handleADAGUCMouseClick = this.handleADAGUCMouseClick.bind(this);
    this._handleWindowResize = this._handleWindowResize.bind(this);
    console.log('Registering webmapjs reducer');
    window.reducerManager.add(WEBMAPJS_REDUCERNAME, webMapJSReducer);
    /* Register this new dimensionSelector reducer with the reducerManager */
    window.reducerManager.add(SPI_MONITOR_REDUCERNAME, spiMonitorReducer);

    this.state = {
      SPISelection: 'spi1',
      getFeatureInfo: [],
      rechartsWidthTop:120,
      rechartsHeightTop:35,
      rechartsWidthBottom:120,
      rechartsHeightBottom:35,
      data: [{}],
      getFeatureInfoL13: [],
      dataL13: [{}],
      dateTicks: []
    };
    props.dispatch(setBaseLayers({ baseLayers: [baseLayer, overLayer], mapPanelId:  'mapid_1' }));
    props.dispatch(setLayers({ layers: [spiLayerDaily, spiLayerForecast], mapPanelId:  'mapid_1' }));
  }

  handleTimeData (dateToHighlight, _selectedSPIToHighlight) {
    let rechartsData = []; let dateTicks = [];
    if (this.dataDaily && this.dataDaily.length && this.dataDaily.length > 0) {
      const selectedSPIToHighlight = 'spi_daily_' + _selectedSPIToHighlight;
      for (let key in this.dataDaily[0].data) {
        var days = moment(dateToHighlight).diff(key, 'days');
        const toBeVisualized = days <= 182;
        let dataObject;
        if (toBeVisualized) {
          if (selectedSPIToHighlight === this.dataDaily[0].name) {
            dataObject = {
              time:key,
              value: parseFloat(this.dataDaily[0].data[key])
            };
          }
          rechartsData.push(dataObject);
        }
      }
    }
    if (this.dataForecast && this.dataForecast.length && this.dataForecast.length > 0) {
      const selectedSPIToHighlight = 'spi_percentile_' + _selectedSPIToHighlight;
      for (let key in this.dataForecast[0].data['50']) {
        const foundTimeIndex = rechartsData.findIndex((e) => { return e.time.substring(0, 10) === key.substring(0, 10); });
        if (foundTimeIndex === -1) {
          let dataObject;
          if (selectedSPIToHighlight === this.dataForecast[0].name ||
             this.dataForecast[0].name === 'sp1percentile' ||
             this.dataForecast[0].name === 'sp3percentile' ||
             this.dataForecast[0].name === 'sp6percentile') {
            dataObject = {
              time:key,
              p50: parseFloat(this.dataForecast[0].data['50'][key]),
              p10: parseFloat(this.dataForecast[0].data['10'][key]),
              p25: parseFloat(this.dataForecast[0].data['25'][key]),
              p75: parseFloat(this.dataForecast[0].data['75'][key]),
              p90: parseFloat(this.dataForecast[0].data['90'][key]),
              pPlumeRange: [parseFloat(this.dataForecast[0].data['90'][key]), parseFloat(this.dataForecast[0].data['10'][key])]
            };
          }
          rechartsData.push(dataObject);
        } else {
          rechartsData[foundTimeIndex].p50 = rechartsData[foundTimeIndex].value;
        }
      }
    }

    const firstDay = moment(rechartsData[0].time); const lastDay = moment(rechartsData[rechartsData.length - 1].time);

    let index = 0;
    dateTicks = [];
    for (var currentDay = firstDay.clone(); currentDay.isSameOrBefore(lastDay); currentDay.add(1, 'days')) {
      if (currentDay.date() == 1) dateTicks.push(rechartsData[index].time);
      index++;
    }

    let lastValueIndex = -1;
    let firstForecastIndex = -1;
    for (let i = 0; i < rechartsData.length; i++) {
      if (rechartsData[i].value != null) {
        lastValueIndex = i;
      }
      if (rechartsData[i].p50 != null && firstForecastIndex === -1) {
        firstForecastIndex = i;
      }
    }
    if (lastValueIndex !== -1 && firstForecastIndex !== -1 && lastValueIndex < firstForecastIndex) {
      rechartsData[lastValueIndex].p50 = rechartsData[lastValueIndex].value;
      rechartsData[lastValueIndex].p10 = rechartsData[lastValueIndex].value;
      rechartsData[lastValueIndex].p90 = rechartsData[lastValueIndex].value;
      rechartsData[lastValueIndex].pPlumeRange = [rechartsData[lastValueIndex].value, rechartsData[lastValueIndex].value];
    }
    this.setState({
      dateTicks: dateTicks,
      getFeatureInfo: rechartsData
    });
  }

  handleL13TimeData (data, dateToHighlight, selectedSPIToHighlight, i) {
    if (!data) { return; }
    let rechartsData = [];
    const layerNames = L13Layer.name.split(',');
    layerNames.forEach(layerName => {
      const layerDataIndex = data.findIndex(i => i.name === (layerName + '_backup'));
      if (layerDataIndex !== -1) {
        for (let key in data[layerDataIndex].data) {
          var days = moment(dateToHighlight).diff(key, 'days');
          const toBeVisualized = days <= 182;
          let timeIndex = rechartsData.findIndex(data => data.time === key);
          if (toBeVisualized) {
            if (timeIndex === -1) {
              rechartsData.push({
                time: key
              });
              timeIndex = rechartsData.length - 1;
            }
            rechartsData[timeIndex][layerName] = parseFloat(data[layerDataIndex].data[key]);
          }
        }
      }
    });
    this.setState({
      getFeatureInfoL13: rechartsData,
      dataL13: data
    }, () => {
      const { dispatch } = this.props;
      dispatch(l13ReadyAction());
    });
  }

  componentDidUpdate (prevProps) {
    if (prevProps.spiMonitor.selectedSPITime !== this.props.spiMonitor.selectedSPITime || prevProps.spiMonitor.selectedSPI !== this.props.spiMonitor.selectedSPI) {
      // this.handleTimeData(this.state.data, newProps.spiMonitor.selectedSPITime, newProps.spiMonitor.selectedSPI);
      if (this.options && this.webmapjs) {
        console.log(this.props.spiMonitor.selectedSPITime, prevProps.spiMonitor.selectedSPITime);
        this.handleADAGUCMouseClick(this.options, this.webmapjs, this.props.spiMonitor.selectedSPITime, this.props.spiMonitor.selectedSPI);
      }
    }
  }

  _handleWindowResize () {
    this.resize();
  }

  resize () {
    const rechartscontainerTop = this.refs.rechartscontainerTop;
    if (rechartscontainerTop) {
      this.setState({
        rechartsWidthTop: parseInt(rechartscontainerTop.clientWidth) - 10,
        rechartsHeightTop: parseInt(rechartscontainerTop.clientHeight)
      });
    }
    const rechartscontainerBottom = this.refs.rechartscontainerBottom;
    if (rechartscontainerBottom) {
      this.setState({
        rechartsWidthBottom: parseInt(rechartscontainerBottom.clientWidth) - 10,
        rechartsHeightBottom: parseInt(rechartscontainerBottom.clientHeight)
      });
    }
  }

  componentDidMount () {
    this.resize();
    window.addEventListener('resize', this._handleWindowResize);

    const URLIs = L13Layer.service + 'request=GetFeatureInfo&version=1.3.0&layers=' + L13Layer.name + '&query_layers=' +
      L13Layer.name + '&crs=EPSG%3A4326&bbox=-511.09859154929575%2C-180%2C511.09859154929575%2C180&width=355&height=1008&i' +
      '=178&j=508&format=image%2Fgif&info_format=application%2Fjson&time=1000-01-01T00%3A00%3A00Z%2F3000-01-01T00%3A00%3A00Z&';

    axios({
      method: 'get',
      url: URLIs,
      responseType: 'json'
    }).then(src => {
      const { spiMonitor } = this.props;
      this.handleL13TimeData(src.data, spiMonitor.selectedSPITime, spiMonitor.selectedSPI);
    }).catch((e) => {
      console.error(e);
      const { dispatch } = this.props;
      dispatch(handleErrorAction('Unable to load L13 data from server.', e));
    });
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this._handleWindowResize);
  }

  renderDot (name, props) {
    const { cx, cy, stroke, key } = props;
    if (cx === +cx && cy === +cy) {
      const dotDate = moment(props.payload.time);
      if (props.payload.time === this.props.spiMonitor.selectedSPITime) {
        return <circle className={'dot ' + name + '-' + dotDate.format('YYYY-MM-DDTHHmm')} cx={cx} cy={cy} r={4} stroke={stroke} fill='#ffffff' key={key} />;
      } else {
        return <circle className={'dot ' + name + '-' + dotDate.format('YYYY-MM-DDTHHmm')} cx={cx} cy={cy} r={0} stroke={stroke} fill='#ffffff' key={key} />;
      }
    }
    return null;
  }

  customTooltip (props, labels, selectedSPI) {
    if (props.payload !== null && props.payload.length !== null && props.payload.length > 0) {
      const labelDate = 'Datum: ' + moment(props.label).locale('nl').format('DD/MM/YYYY');
      // const labels = ['90p', '50p', '10p'];
      // eslint-disable-next-line no-unused-vars
      const payload = props.payload.reverse();
      // let forecast = false;
      // try {
      //   if (props.payload[0].payload.p10 && props.payload[0].payload.p90) {
      //     forecast = true;
      //   }
      // } catch (e) {
      // }
      return (
        <div className='recharts-tooltip-wrapper' style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', border: '1px solid rgb(204, 204, 204)', padding: '0.2rem 1rem 0 1rem', fontSize: '14px' }}>
          <ul className='recharts-tooltip-item-list' style={{ paddingLeft: '0rem', marginTop: 0, marginBottom: 0, listStyleType: 'none' }}>
            <li className='recharts-tooltip-label'>{labelDate}</li>
            {<li key='median' className='recharts-tooltip-item' style={{ color: props.payload[0].color }}>
              {selectedSPI.toUpperCase().split(/(\d+)/)[0] + ' ' + selectedSPI.split(/(\d+)/)[1] + ': ' + props.payload[0].value.toFixed(2)}
            </li>}
            {/* {forecast && <li key={'test'} className='recharts-tooltip-item' style={{ color: payload[1].color }}>
              {selectedSPI.toUpperCase().split(/(\d+)/)[0] + ' ' + selectedSPI.split(/(\d+)/)[1] + ': ' + payload[0].value.toFixed(2)}
            </li>} */}
          </ul>
        </div>);
    } else {
      return <div />;
    }
  }

  customTooltipL13 (props, labels, selectedSPI) {
    if (props.payload !== null && props.payload.length !== null && props.payload.length > 0) {
      const labelDate = 'Datum: ' + moment(props.label).locale('nl').format('DD/MM/YYYY');
      const payload = props.payload.reverse();
      const labels = ['90p', '50p', '10p'];
      let allTheSame = false;
      try {
        if (props.payload[0].value === props.payload[1].value && props.payload[1].value === props.payload[2].value) {
          console.log('eq');
          allTheSame = true;
        }
      } catch (e) {
      }
      return (
        <div className='recharts-tooltip-wrapper' style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', border: '1px solid rgb(204, 204, 204)', padding: '0.2rem 1rem 0 1rem', fontSize: '14px' }}>
          <ul className='recharts-tooltip-item-list' style={{ paddingLeft: '0rem', marginTop: 0, marginBottom: 0, listStyleType: 'none' }}>
            <li className='recharts-tooltip-label'>{labelDate}</li>
            {!allTheSame && payload.map((pl, i) => <li key={i} className='recharts-tooltip-item' style={{ color: payload[i].color }}>
              {labels[i < 3 ? i : 0] + ': ' + payload[i].value.toFixed(2)}
            </li>)}
            {allTheSame && <li key='median' className='recharts-tooltip-item' style={{ color: payload[0].color }}>
              {selectedSPI.toUpperCase().split(/(\d+)/)[0] + ' ' + selectedSPI.split(/(\d+)/)[1] + ': ' + payload[0].value.toFixed(2)}
            </li>}
          </ul>
        </div>);
    } else {
      return <div />;
    }
  }

  handleADAGUCMouseClick (options, webmapjs, selectedSPITime, selectedSPI) {
    console.log('handleADAGUCMouseClick', selectedSPI);
    const { dispatch } = this.props;
    dispatch(spiLoadingAction(true));

    const observationPromise = GetFeatureInfo(spiLayerDaily, options, webmapjs, selectedSPITime);
    const forecastPromise = GetFeatureInfo(spiLayerForecast, options, webmapjs, selectedSPITime);
    this.dataDaily = null;
    this.dataForecast = null;
    Promise.all([observationPromise, forecastPromise]).then(data => {
      console.log(data);
      this.dataDaily = data[0];
      this.dataForecast = data[1];
      this.handleTimeData(selectedSPITime, selectedSPI);
    }).catch((e) => {
      dispatch(handleErrorAction('Unable to do GetFeatureInfo, unable to get timeseries.', e));
    }).finally(() => {
      dispatch(spiLoadingAction(false));
    });
  }

  render () {
    const { mapPanel, dispatch, spiMonitor } = this.props;
    if (!mapPanel || !mapPanel.length || mapPanel.length < 1) {
      return (<div>mapPanel props not set</div>);
    }
    // const spiNumber = spiMonitor.selectedSPI.replace('spi', '');
    return (
      <div className='MapChartContent'>
        <div className='MapViewer'>
          <ReactWMJSMap
            id={'mapid_1'}
            controls={{
              buttonZoomOut: true,
              buttonZoomHome: false,
              buttonZoomIn: true
            }
            }
            dispatch={dispatch}
            webMapJSInitializedCallback={(webmapjs) => {
              this.webmapjs = webmapjs;
              webmapjs.enableInlineGetFeatureInfo(false);
              webmapjs.displayLegendInMap(true);
              webmapjs.showInfoInMap = false;
              webmapjs.setProjection({
                srs:'EPSG:28992',
                bbox: '-51787.14,147184.50,296784.08,768832.99'
                // bbox: left, bottom, right, top
                // coordinates in EPSG:4326 => 2°32'46.307", 49°16'51.082", 7°35'44.094", 54°52'59.076"
              });
              webmapjs.addListener('mouseclicked', (options) => {
                const { spiMonitor } = this.props;
                this.options = options;
                this.handleADAGUCMouseClick(this.options, this.webmapjs, spiMonitor.selectedSPITime, spiMonitor.selectedSPI);
              }, true);
            }}
          >
            {/* There is a BUG in react-webmapjs which prevents correctly setting the baselayers.
            { mapPanel[0].baseLayers.map((layer, i) => { return <ReactWMJSLayer key={i} {...layer} />; }) } */}
            <ReactWMJSLayer {...overLayer} />
            { mapPanel[0].layers.map((layer, i) => {
              return <ReactWMJSLayer onLayerReady={(layer, webMapJS) => {
                layer.legendGraphicHeight = 180;
                [layer.getDimension('time'), webMapJS.getDimension('time')].forEach((timeDimension) => {
                  if (timeDimension) {
                    normaliseTimeDimensionUnits(timeDimension);
                  }
                });
                if (!this.initialClickHandled) {
                  this.initialClickHandled = true;
                  const { spiMonitor } = this.props;
                  let deBiltPxCoord = this.webmapjs.getPixelCoordFromLatLong({ x: 5.1809676, y: 52.1092717 });
                  const initClickLocation = {
                    x: deBiltPxCoord.x,
                    y: deBiltPxCoord.y,
                    map: this.webmapjs
                  };
                  this.options = initClickLocation;
                  // selectedSPITime is set asynchronously by FooterContainer once the layer time dimension is known.
                  // componentDidUpdate fires the initial GetFeatureInfo as soon as it changes from '' to a real value.
                  if (spiMonitor.selectedSPITime !== '') {
                    this.handleADAGUCMouseClick(initClickLocation, this.webmapjs, spiMonitor.selectedSPITime, spiMonitor.selectedSPI);
                  }
                  this.webmapjs.setMapPin(initClickLocation.x, initClickLocation.y);
                  if (this.webmapjs.layers.length > 0) {
                    this.webmapjs.layers[0].zoomToLayer();
                  }
                }
              }} key={i} {...layer} />;
            }) }
          </ReactWMJSMap>
        </div>
        <div className='TopChartViewer'>
          { spiMonitor.spiIsLoading && <div className={'loadingDiv'}><Icon spin name='spinner' /></div> }
          <div style={{ height: '100%' }}>
            <div className={'TopChartViewerTitle'}>{spiMonitor.selectedSPI.toUpperCase().split(/(\d+)/)[0]} {spiMonitor.selectedSPI.split(/(\d+)/)[1]} mnd - Lokatie op de kaart </div>
            <div className='RechartsArea' ref={(container) => { this.container = container; }}
              style={{ height:'100%', width:'100%', border:'none', display:'block', overflow:'hidden' }} >
              <div ref='rechartscontainerTop' style={{
                minWidth:'inherit',
                minHeight:'inherit',
                width: 'inherit',
                height: 'inherit',
                overflow: 'hidden',
                display:'block',
                border: 'none'
              }}>
                <div style={{ overflow: 'visible', height:'0px', width: '0px' }} >
                  <AreaChart width={this.state.rechartsWidthTop} height={this.state.rechartsHeightTop - 40} data={this.state.getFeatureInfo}>
                    <XAxis dataKey='time'
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        lineHeight: '18px'
                      }}
                      ticks={this.state.dateTicks}
                      tickFormatter={v => moment(v).locale('nl').format('MMM YY')} />
                    <YAxis width={70} padding={{ top: 3, bottom: 3 }} tick={false} domain={[-2, 2]} type='number' />
                    <CartesianGrid fill='lightgrey' fillOpacity={0.3} vertical={false} />
                    <Tooltip content={(props) => this.customTooltip(props, 'value', spiMonitor.selectedSPI)} />
                    <ReferenceLine y='-2' stroke='#A72C32' strokeWidth={2} label={{ position:'left', value: 'Extreem droog', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='-1.5' stroke='#F15922' strokeWidth={2} label={{ position: 'left', value: 'Zeer droog', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='-1' stroke='#FCBA62' strokeWidth={2} label={{ position: 'left', value: 'Vrij droog', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='0' stroke='#D6EEEC' strokeWidth={2} label={{ position: 'left', value: 'Normaal', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='1' stroke='#03A4E1' strokeWidth={2} label={{ position: 'left', value: 'Vrij nat', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='1.5' stroke='#4D57A6' strokeWidth={2} label={{ position: 'left', value: 'Zeer nat', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='2' stroke='#3F3F99' strokeWidth={2} label={{ position: 'left', value: 'Extreem nat', fontSize: 10, fill:'#000000' }} />
                    <Area name={spiMonitor.selectedSPI} type='linear' dataKey='value' stroke='#000000' fillOpacity='0' strokeWidth={2} dot={(props) => this.renderDot('value', props)} />
                    {/* <Area name='p10' type='monotone' dataKey='p10' stroke='#808080' fillOpacity='0' strokeWidth={0} activeDot={false} /> */}
                    <Area name='pPlumeRange' type='monotone' dataKey='pPlumeRange' stroke='#000000' fill='#808080' activeDot={false} strokeWidth={0} />
                    <Area name='p50' type='linear' dataKey='p50' stroke='#000000' strokeWidth={2} fillOpacity='0' strokeDasharray='3 3' dot={(props) => this.renderDot('value', props)} />
                    {/* <Area name='p90' type='monotone' dataKey='p90' stroke='#808080' fillOpacity='0' strokeWidth={0} activeDot={false} /> */}
                  </AreaChart>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='BottomChartViewer'>
          { spiMonitor.loadingL13 && <div className={'loadingDiv'}><Icon spin name='spinner' /></div> }
          <div style={{ height: '100%' }} >
            <div className={'BottomChartViewerTitle'}>{spiMonitor.selectedSPI.toUpperCase().split(/(\d+)/)[0]} {spiMonitor.selectedSPI.split(/(\d+)/)[1]} mnd - Landelijk gemiddelde</div>
            <div className='RechartsArea' ref={(container) => { this.container = container; }}
              style={{ height:'100%', width:'100%', border:'none', display:'block', overflow:'hidden' }} >
              <div ref='rechartscontainerBottom' style={{
                minWidth:'inherit',
                minHeight:'inherit',
                width: 'inherit',
                height: 'inherit',
                overflow: 'hidden',
                display:'block',
                border: 'none'
              }} >
                <div style={{ overflow: 'visible', height:'0px', width: '0px' }} >
                  <AreaChart width={this.state.rechartsWidthBottom} height={this.state.rechartsHeightBottom - 40}
                    data={this.state.getFeatureInfoL13
                    }>
                    <XAxis dataKey='time'
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        lineHeight: '18px'
                      }}
                      tickFormatter={v => moment(v).locale('nl').format('MMM YY')} interval={30} />
                    <YAxis width={70} padding={{ top: 20, bottom: 20 }} tick={false} domain={[-2, 2]} type='number' />
                    <CartesianGrid fill='lightgrey' fillOpacity={0.3} vertical={false} />
                    <Tooltip content={(props) => this.customTooltipL13(props, 'SPI_NL_1_10', spiMonitor.selectedSPI)} />
                    <ReferenceLine y='-2' stroke='#8B4513' strokeWidth={2} label={{ position: 'left', value: 'Extreem droog', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='-1.5' stroke='#FFF000' strokeWidth={2} label={{ position: 'left', value: 'Zeer droog', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='-1' stroke='#B5FF33' strokeWidth={2} label={{ position: 'left', value: 'Vrij droog', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='0' stroke='#008000' strokeWidth={2} label={{ position: 'left', value: 'Normaal', fontSize: 10, fill:'#000000' }}/>
                    <ReferenceLine y='1' stroke='#33FFD7' strokeWidth={2} label={{ position: 'left', value: 'Vrij nat', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='1.5' stroke='#33FFF9' strokeWidth={2} label={{ position: 'left', value: 'Zeer nat', fontSize: 10, fill:'#000000' }} />
                    <ReferenceLine y='2' stroke='#8A2BE2' strokeWidth={2} label={{ position: 'left', value: 'Extreem nat', fontSize: 10, fill:'#000000' }} />
                    <Area name={'L13 ' + spiMonitor.selectedSPI} type='linear' dataKey={'SPI_NL_' + spiNumber + '_10'}
                      stroke='#808080' strokeWidth={2} fillOpacity='0' dot={(props) => this.renderDot('SPI_NL_1_10', props)} />
                    <Area name={'L13 ' + spiMonitor.selectedSPI} type='linear' dataKey={'SPI_NL_' + spiNumber + '_90'}
                      stroke='#808080' strokeWidth={2} fillOpacity='0' dot={(props) => this.renderDot('SPI_NL_1_90', props)} />
                    <Area name={'L13 ' + spiMonitor.selectedSPI} type='linear' dataKey={'SPI_NL_' + spiNumber + '_50'}
                      stroke='#000000' strokeWidth={2} fillOpacity='0' dot={(props) => this.renderDot('SPI_NL_1_50', props)} />
                  </AreaChart>
                </div>
              </div>
            </div>
          </div>
        </div> */
        }
      </div>
    );
  }
};

Content.propTypes = {
  mapPanel: PropTypes.array.isRequired,
  dispatch: PropTypes.func,
  spiMonitor: PropTypes.object
};

const mapStateToProps = state => {
  /* Return initial state if not yet set */
  const webMapJSState = state[WEBMAPJS_REDUCERNAME] ? state[WEBMAPJS_REDUCERNAME] : webMapJSReducer();
  return {
    mapPanel: webMapJSState.webmapjs.mapPanel,
    spiMonitor: state[SPI_MONITOR_REDUCERNAME] ? state[SPI_MONITOR_REDUCERNAME] : spiMonitorReducer()
  };
};

export default connect(mapStateToProps)(Content);
